export default {"src":"/_next/static/media/always-more.33e4d60d.svg","height":398,"width":341,"blurWidth":0,"blurHeight":0};